import React from "react";
import { Button, ModalFooter } from "reactstrap";
import { useViewEditTenderStore } from "../../../../../../Stores/viewEditTender";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useVademecumStore } from "../../../../../../Stores/vademecumStore";
import { returnTenderTitle } from "../summaryResultModal";
import XLSXDownloadButton from "../../XLSX/XLSXDownloadButton";
import { useAuthStore } from "../../../../../../Stores/authStore";
import { DownloadPDFButton } from "../../PDF/SummaryPDFTableStyle";

export default function SummaryModalFooter({ adminSwitch, setAdminSwitch }) {
  const { t, i18n } = useTranslation();
  const [
    setSummaryResultModalVisible,
    summary,
    summaryStatus,
    summaryFieldValuesStatus,
    tenderStatus,
    tender,
    summaryFieldValues,
  ] = useViewEditTenderStore((state) => [
    state.setSummaryResultModalVisible,
    state.summary,
    state.summaryStatus,
    state.summaryFieldValuesStatus,
    state.tenderStatus,
    state.tender,
    state.summaryFieldValues,
  ]);
  const [setEmailUserModalVisible] = useVademecumStore((state) => [state.setEmailUserModalVisible]);

  return (
    <ModalFooter className="d-flex justify-content-between flex-column flex-sm-row justify-content-between">
      <Button
        className="tc-full-width-small"
        onClick={() => {
          setSummaryResultModalVisible(false);
        }}
        type="button"
        color="danger"
      >
        {t("Close")}
      </Button>
      {adminSwitch && (summaryStatus === "loaded" || summaryStatus === "saving") ? (
        <Link
          className="tc-full-width-small"
          to={`/${i18n.language.slice(0, 2)}/admin/view_tender/${summary.tender}`}
          target="_blank"
        >
          <Button className="tc-full-width-small" type="button" color="secondary">
            {t("Edit Tender")}
          </Button>
        </Link>
      ) : null}
      {useAuthStore.getState()?.user?.is_superuser ? (
        <Button
          className={`me-auto tc-full-width-small ${tenderStatus === "loaded" ? "" : "disabled"}`}
          onClick={() => {
            setEmailUserModalVisible(true);
          }}
          type="button"
          color="secondary"
        >
          {t("Email User")}
        </Button>
      ) : null}
      {summaryFieldValuesStatus === "saving" || summaryStatus === "saving" ? (
        <div className="me-auto ms-auto">{t("Saving changes...")}</div>
      ) : null}
      {tenderStatus === "loaded" && (summaryStatus === "loaded" || summaryStatus === "saving") ? (
        <div className="d-flex tc-flex-gap-10px flex-column flex-sm-row tc-full-width-small">
          <DownloadPDFButton
            key={`${JSON.stringify(summaryFieldValues)}_${JSON.stringify(tender)}`}
            title={returnTenderTitle(tender, i18n.language.slice(0, 2))}
          />

          <XLSXDownloadButton tenderTitle={returnTenderTitle(tender, i18n.language.slice(0, 2))} />
          {useAuthStore.getState()?.user?.is_superuser ? (
            <Button
              className="tc-full-width-small"
              onClick={() => {
                setAdminSwitch(!adminSwitch);
              }}
              type="button"
              color="secondary"
            >
              {adminSwitch ? t("Switch to View") : t("Switch to Edit")}
            </Button>
          ) : null}
        </div>
      ) : null}
    </ModalFooter>
  );
}
